import { Checkbox, Form, message } from "antd";
import { ErrorMessage, Field, Formik } from "formik";
import React, { useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PartnerLogin } from "../../Api/Login/AllLogin";

// const emailOrPhoneValidation = Yup.string().test(
//   "emailOrPhone",
//   "Invalid email or phone number format",
//   (value) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\d{10}$/;
//     return emailRegex.test(value) || phoneRegex.test(value);
//   }
// );

const validationSchema = Yup.object().shape({
   emailid_phone: Yup.string()
    .required("Email or Phone is required")
    .max(40, "Maximum 40 characters allowed")
    .test("validate-email-or-phone", function (value) {
      const { path, createError } = this;

      const isEmail = value?.includes("@");
      const onlyDigits = /^\d+$/.test(value);

      // ✅ EMAIL VALIDATION
      if (isEmail) {

        const emailRegex =
          /^[a-zA-Z0-9]+[a-zA-Z0-9._%]*[a-zA-Z0-9]@[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/;

        // ❌ invalid email → show message
        if (!emailRegex.test(value)) {
          return createError({
            path,
            message: "Special characters are not allowed.",
          });
        }

        // duplicate domain parts → reject
        const domain = value.split("@")[1] || "";
        const tlds = domain.split(".");

        if (tlds.length >= 2 && tlds.at(-1) === tlds.at(-2)) {
          return createError({
            path,
            message: "Invalid domain format",
          });
        }

        return true; // VALID EMAIL
      }

      // ✅ PHONE VALIDATION
      if (onlyDigits) {
        if (value.length !== 10) {
          return createError({
            path,
            message: "Phone number must be 10 digits",
          });
        }

        if (!/^[6-9]/.test(value)) {
          return createError({
            path,
            message: "Phone number must start with 6, 7, 8, or 9",
          });
        }

        return true;
      }

      // ❌ NON-EMAIL + NON-PHONE
      return createError({
        path,
        message: "Enter a valid Email or Phone Number",
      });
    }),
  password: Yup.string().required("Password is required")
  // .max(20,"Maximum 20 Charaters Only"),
});

export default function Partner({ setForgotPassword,setLoading }) {

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  //const [toastError, setToastError] = useState();
  const validateInput = (input) => {
    const emailRegex = /\S+@\S+\.\S+/;
    const phoneRegex = /^\d{10}$/;
    if (emailRegex.test(input)) {
      return 1; // Email
    } else if (phoneRegex.test(input)) {
      return 2; // Phone
    }
    return 0; // Invalid
  };

  const handleSubmit = async (values,{setFieldError}) => {
    setLoading(true)
    const validationResult = validateInput(values.emailid_phone);
    try {
      const data = await PartnerLogin(values, validationResult);
    
      console.log(data, "partnerdataata")
      // toast.warning(data?.message);
      if (data?.token !== undefined) {
        console.log(data, "data2");
        navigate("/dashboard");
        window.location.reload();
      }else {
        if(data.message.status===202){
          setFieldError("emailid_phone","Invalid Email or Phone number")
        }
        else if( 
          data.message.status===203){ 
          setFieldError("password","Invalid Password")
          }
        
      }
    } catch (error) {
      if (error.response && error.response.status === 203) {
        setFieldError("password", " Invalid Email or Phone number");
        // toast.error("Invalid Password / Username");
      } else {
        toast.error(error.message);
      }
    } 
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="absolute left-0 top-0 bg-[#E5FFF1] h-full w-[35vw] rounded-tl-[2vw] rounded-bl-[2vw] bg-opacity-90 flex flex-col items-center justify-center">
      <label className="text-[#1F487C] font-bold text-[2vw] ">
        PARTNER
      </label>
      <p className="text-[#1F487C]  text-[1vw] py-[2vw]">
        Welcome Back, Please sign in to your account
      </p>

      <Formik
        initialValues={{
          emailid_phone: "",
          password: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values,{setFieldError}) => {
          handleSubmit(values,{setFieldError});
        }}
      >
        {({ isSubmitting, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="gap-y-[1.5vw] flex-col flex">
              {/* Email / Phone Field */}
              <div className="col-span-1 relative ">
                <label className="text-[#1F487C] text-[1.1vw]">
                  Email / Phone
                  <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
                </label>
                <Field
                  type="text"
                  name="emailid_phone"
                   maxLength={40}
                  placeholder="Enter Email / Phone Number"
                  className="border-r-[0.3vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                />
                <ErrorMessage
                  name="emailid_phone"
                  component="div"
                  className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                />
              </div>

              {/* Password Field */}
              <div className="col-span-1 relative">
                <label className="text-[#1F487C] text-[1.1vw]">
                  Password
                  <span className="text-[1vw] text-red-600 pl-[0.2vw]">*</span>
                </label>
                <div className="relative flex items-center">
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    maxLength={30}
                    placeholder="Enter Password"
                    className="border-r-[0.3vw] mt-[0.5vw] pr-[3vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]"
                  />
                  <div
                    className="absolute right-[1vw] cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <FaEye className="text-[1.5vw] text-[#1F487C]" />
                    ) : (
                      <FaEyeSlash className="text-[1.5vw] text-[#1F487C]" />
                    )}
                  </div>
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                />
              </div>

              {/* Remember Me and Forgot Password */}
             <div className="flex justify-between items-center">
                <div className="flex justify-between items-center gap-[0.7vw]">
                  {/* <Checkbox> */}
                  <input
                    type="checkbox"
                    onChange={(e) => {}}
                    className="h-[.9vw] w-[.9vw] cursor-pointer "
                  />
                  <span className="text-[#1F4B7F]  text-[1vw] ">
                    Remember me
                  </span>
                  {/* </Checkbox> */}
                </div>
                <div>
                  <p
                    className="text-[#1F487C] text-[1vw] cursor-pointer"
                    onClick={() => setForgotPassword(true)}
                  >
                    Forgot Password
                  </p>
                </div>
              </div>

              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  //disabled={isSubmitting}
                  onClick={handleSubmit}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-[1.2vw] font-medium text-white bg-[#1F487C]"
                >
                  Sign In
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
